module.exports = __webpack_public_path__ + "static/img/pic_ai_video_4.8b4813a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic_ai_video_4.gif
// module id = 0yci
// module chunks = 1